module.exports = __webpack_public_path__ + "img/16.9cb1aa5b.jpg";